import React from 'react';
import {
  Box,
  Button,
  Stack,
  SvgMagnifyingGlass,
} from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

interface TableSearchFormProps {
  placeholder: string;
  onSearchClick: () => void;
}

export const TableSearchForm: React.FC<TableSearchFormProps> = ({
  placeholder,
  onSearchClick,
}) => {
  const { control } = useFormContext();

  return (
    <Stack display="flex">
      <Stack x="x-sm" flex={1} position="relative">
        <CookbookInputWrapper
          blockWidth
          name="searchInput"
          control={control}
          placeholder={placeholder}
          onKeyPress={(evt) => {
            if (evt.key === 'Enter') {
              onSearchClick();
            }
          }}
          prefixDecorator={
            <Box color="secondaryText">
              <SvgMagnifyingGlass size="20px" />
            </Box>
          }
        />
      </Stack>

      <Button onClick={() => onSearchClick()}>Search</Button>
    </Stack>
  );
};
